import $ST from "plugins/tfs/platformConfigs/staticTextMaps/checkout";
import React from "react";
import Modal from "theme/Modal";
import Error from "theme/Error";
import Button from "theme/Button";
import Checkbox from "theme/CheckBox";

import Widget from "theme/widgets";
// pageContainer
import Agreement from "_pageContainers/checkout/agreement";

const AGREEMENT_TYPES = {
  DEFAULT: "default",
  FUND_TRANSFER: "fundTransfer",
};

const AgreementGrid = (pageContext) => {
  const {
    props: {
      error,
      onAgreement,
      checked,
      agreementType = AGREEMENT_TYPES.DEFAULT,
    },
    userAgreementModal,
    privacyPolicyModal,
    openModal,
    closeModal,
  } = pageContext;

  const isFundTransferAgreement =
    agreementType === AGREEMENT_TYPES.FUND_TRANSFER;
  const agreementBodyText = isFundTransferAgreement
    ? $ST.FUND_TRANSFER_AGREEMENT.AGREEMENT_TEXT
    : $ST.READ_AND_AGREE;
  const agreementPart1 = isFundTransferAgreement
    ? $ST.FUND_TRANSFER_AGREEMENT.PART1
    : $ST.USER_AGREEMENT.PART1;
  const agreementPart2 = isFundTransferAgreement
    ? $ST.FUND_TRANSFER_AGREEMENT.PART2
    : $ST.USER_AGREEMENT.PART2;

  return (
    <div className="agreement">
      {userAgreementModal && (
        <Modal onClose={closeModal}>
          <div className="modal-text">
            <Widget path="user.user_agreement" />
          </div>
        </Modal>
      )}
      {privacyPolicyModal && (
        <Modal onClose={closeModal}>
          <div className="modal-text">
            <Widget path="user.privacy_policy" />
          </div>
        </Modal>
      )}
      <label>
        <Checkbox
          name="agreement"
          icon="check"
          value="checked"
          checked={checked}
          onChange={(checked) => {
            onAgreement(checked);
          }}
        />
        <div className="agreement-body">
          {` ${agreementBodyText}`}{" "}
          <Button
            classes="open pointer agreement-link"
            onClick={() => openModal("userAgreementModal")}
          >
            {agreementPart1}
          </Button>
          {` ${agreementPart2} `}
          <Button
            classes="open pointer agreement-link"
            onClick={() => openModal("privacyPolicyModal")}
          >
            {` ${$ST.PRIVACY_POLICY} `}
          </Button>
        </div>
      </label>
      <Error data={error} field="agreement" />
    </div>
  );
};

export default Agreement(AgreementGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/checkout/agreement/index.js